// src/core/routes.js
import "../instances/public/components/adminMode"; // Admin-Modus-Token früh übernehmen (vor dem Cookie-Banner)
import { BrowserRouter as Router } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import { getConsent } from "../components/consent";

// CSS
import "../shared/style/css/core.css";

import { isRentalBrand } from "./brand";
import ScrollToTop from "../components/ScrollToTop";
import CookieBanner from "../components/CookieBanner";
import ErrorBoundary from "../components/ErrorBoundary";

// Sub Routing – lazy: jede Instanz wird nur geladen, wenn der
// passende Hostname tatsächlich aufgerufen wird. Ein Besucher auf
// gotransfer24.de lädt so NIE den Code für Partner/Driver/Admin mit.
const PartnerRoutes = lazy(() => import("../instances/partner/main"));
const PublicRoutes = lazy(() => import("../instances/public/main"));
const DriverRoutes = lazy(() => import("../instances/driver/main"));
const AdminRoutes = lazy(() => import("../instances/admin/main"));
const RentalRoutes = lazy(() => import("../instances/rental/main"));

const hostname = window.location.hostname;
// Kundenwebseiten-Widget (iframe): weder Cookie-Banner noch Sitzungsaufzeichnung
const isWidgetFrame = window.location.pathname === "/widget" || window.location.pathname.startsWith("/qr/"); // + QR-Weiterleitung: nur Ladebildschirm

// Öffentliche Seite (www.gotransfer24.de): Das Instanz-Modul wird VOR dem ersten Rendern geladen (siehe index.js) und dann ohne
// <Suspense> eingebunden. Grund: Das von react-snap vorgerenderte HTML enthält keine Suspense-Marker – ein Suspense im Baum
// ließe die Hydration scheitern, die Seite würde komplett neu aufgebaut (Bild/LCP wird neu gezeichnet, Mehraufwand).
const isPublicHost = !isRentalBrand && !["partners.gotransfer24.de", "driver.gotransfer24.de", "admin.gotransfer24.de"].includes(hostname);
let PublicRoutesLoaded = null;
export const preloadPublicRoutes = () =>
  isPublicHost
    ? import("../instances/public/main").then((m) => { PublicRoutesLoaded = m.default; return m.preloadForPath ? m.preloadForPath(window.location.pathname) : null; })
    : Promise.resolve();

function AppRoutes() {
  // Sitzungsaufzeichnung: nur mit Einwilligung laden (eigener Chunk, rrweb erst beim Start)
  useEffect(() => {
    if (isWidgetFrame) return;
    const run = () => { if (getConsent().recording) import("../components/sessionRecorder").then((m) => m.initRecorder()); };
    run();
    window.addEventListener("consent-changed", run);
    return () => window.removeEventListener("consent-changed", run);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      {!isWidgetFrame && <CookieBanner />}
      <ErrorBoundary>
      {PublicRoutesLoaded ? (
        <PublicRoutesLoaded />
      ) : (
      <Suspense fallback={null}>
        {hostname === "partners.gotransfer24.de" ? (
          <PartnerRoutes />
        ) : hostname === "driver.gotransfer24.de" ? (
          <DriverRoutes />
        ) : hostname === "admin.gotransfer24.de" ? (
          <AdminRoutes />
        ) : isRentalBrand ? (
          <RentalRoutes />
        ) : (
          <PublicRoutes />
        )}
      </Suspense>
      )}
      </ErrorBoundary>
    </Router>
  );
}

export default AppRoutes;